import PropTypes from "prop-types";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import ItemWithHandle from "UI/FnrDragNDrop/ItemWithHandle";
import FnrIconWithTooltip from "UI/FnrIconWithTooltip";
import FnrLabeledIcon from "UI/FnrLabeledIcon/FnrLabeledIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";

import ItemContainer from "../ItemContainer";

const InfoIcons = ({ required, fromProfile }) => (
  <FnrHorizontalGap
    fullWidth
    justifyContent="space-between"
    style={{ marginRight: "4px" }}
  >
    {fromProfile && (
      <FnrIconWithTooltip
        icon="fa-id-badge far"
        tooltipText="Updates user profile info"
      />
    )}
    {required && (
      <FnrIconWithTooltip
        icon="fa-asterisk fas"
        tooltipText="Required"
        style={{ marginLeft: "auto" }}
      />
    )}
  </FnrHorizontalGap>
);

InfoIcons.propTypes = {
  required: PropTypes.bool,
  fromProfile: PropTypes.bool,
};

const ItemComponent = ({
  onPointerDown,
  item: { children, icon, id, required, fromProfile },
  allItems,
}) => {
  const [fieldId, setFieldId] = extendedFieldHooks.useSelectedFieldId();
  const [, setIsNavigating] = extendedFieldHooks.useIsNavigating();
  const isSignupVariant = extendedFieldHooks.useVariant() === "signup";

  const handleClick = () => {
    setFieldId(id);
    setIsNavigating(false);
  };

  const selected = fieldId === id;

  return (
    <ItemContainer
      $selected={selected}
      data-cy={"FieldDragListItem_ItemContainer"}
      onClick={handleClick}
      $isSignupVariant={isSignupVariant}
    >
      <ItemWithHandle
        onPointerDown={onPointerDown}
        hasHandle={allItems?.length > 1}
      >
        <FnrHorizontalGap fullWidth justifyContent="flex-start">
          <FnrLabeledIcon icon={icon} data-cy={"FieldDragListItem_LabeledIcon"}>
            {children}
          </FnrLabeledIcon>
          <InfoIcons
            required={Boolean(required)}
            fromProfile={Boolean(fromProfile)}
          />
        </FnrHorizontalGap>
      </ItemWithHandle>
    </ItemContainer>
  );
};

ItemComponent.propTypes = {
  onPointerDown: PropTypes.func.isRequired,
  item: PropTypes.shape({
    children: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }),
};

export default ItemComponent;
